"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$appdx = exports.$appdxFormat = exports.$appdxNote = exports.$appdxStyle = exports.$appdxTable = exports.$appdxFig = exports.makeAppdxItemRule = exports.appdxItemToLines = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_2 = require("../../cst/util");
const inline_1 = require("../../../node/cst/inline");
const el_1 = require("../../../node/el");
const util_3 = require("../../../util");
const _remarks_1 = __importStar(require("./$remarks"));
const _noteLike_1 = require("./$noteLike");
const _figStruct_1 = __importStar(require("./$figStruct"));
const _paragraphItem_1 = require("./$paragraphItem");
const _tableStruct_1 = __importStar(require("./$tableStruct"));
const _arithFormula_1 = __importStar(require("./$arithFormula"));
const _appdxItemHeadLine_1 = require("../../cst/rules/$appdxItemHeadLine");
const _sentenceChildren_1 = require("../../cst/rules/$sentenceChildren");
const _tagControl_1 = require("../../cst/rules/$tagControl");
/**
 * The renderer for appended items ({@link std.AppdxItem | AppdxItem}). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$appdxItem.spec.ts) for examples.
 */
const appdxItemToLines = (appdxItem, indentTexts) => {
    const lines = [];
    const appdxItemTitleTag = std_1.appdxItemTitleTags[std_1.appdxItemTags.indexOf(appdxItem.tag)];
    const appdxItemTitleSentenceChildren = appdxItem.children
        .find(el => el.tag === appdxItemTitleTag)?.children;
    const relatedArticleNumSentenceChildren = appdxItem.children
        .find(el => el.tag === "RelatedArticleNum")?.children;
    lines.push(new line_1.AppdxItemHeadLine({
        range: null,
        indentTexts,
        mainTag: appdxItem.tag,
        controls: appdxItemTitleSentenceChildren && (0, _appdxItemHeadLine_1.detectAppdxItemTitle)((0, _sentenceChildren_1.sentenceChildrenToString)(appdxItemTitleSentenceChildren)) === appdxItem.tag ? [
            new inline_1.Control(_tagControl_1.autoTagControls[0], null, " ", null)
        ] : [
            new inline_1.Control(_tagControl_1.appdxItemControls[appdxItem.tag], null, "", null)
        ],
        title: (0, util_2.mergeAdjacentTextsWithString)(appdxItemTitleSentenceChildren ?? []),
        relatedArticleNum: (0, util_2.mergeAdjacentTextsWithString)(relatedArticleNumSentenceChildren ?? []),
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    for (const [ci, child] of appdxItem.children.entries()) {
        if ((0, std_1.isAppdxItemTitle)(child))
            continue;
        if ((0, std_1.isRelatedArticleNum)(child))
            continue;
        if ((0, std_1.isNoteLikeStruct)(child)) {
            lines.push(...(0, _noteLike_1.noteLikeStructToLines)(child, childrenIndentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isRemarks)(child)) {
            lines.push(...(0, _remarks_1.remarksToLines)(child, childrenIndentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isFigStruct)(child)) {
            lines.push(...(0, _figStruct_1.figStructToLines)(child, childrenIndentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isParagraphItem)(child)) {
            lines.push(...(0, _paragraphItem_1.paragraphItemToLines)(child, childrenIndentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isTableStruct)(child)) {
            const withControl = ((0 <= (ci - 1) && (0, std_1.isTableStruct)((appdxItem.children[ci - 1]))) ||
                ((ci + 1) < appdxItem.children.length && (0, std_1.isTableStruct)((appdxItem.children[ci + 1]))));
            lines.push(...(0, _tableStruct_1.tableStructToLines)(child, childrenIndentTexts, { withControl }));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if ((0, std_1.isArithFormula)(child)) {
            lines.push(...(0, _arithFormula_1.arithFormulaToLines)(child, childrenIndentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else {
            (0, util_3.assertNever)(child);
        }
    }
    return lines;
};
exports.appdxItemToLines = appdxItemToLines;
const appdxItemContentRule = {
    AppdxFig: (factory_1.factory
        .choice(c => c
        .or(() => _figStruct_1.default)
        .or(() => _tableStruct_1.default))),
    AppdxStyle: (factory_1.factory
        .choice(c => c
        .or(() => _noteLike_1.$styleStruct)
        .or(() => _remarks_1.default))),
    AppdxFormat: (factory_1.factory
        .choice(c => c
        .or(() => _noteLike_1.$formatStruct)
        .or(() => _remarks_1.default))),
    AppdxTable: (factory_1.factory
        .choice(c => c
        .or(() => _tableStruct_1.default)
        .or(() => _paragraphItem_1.$requireControlParagraphItem)
        .or(() => _remarks_1.default))),
    AppdxNote: (factory_1.factory
        .choice(c => c
        .or(() => _noteLike_1.$noteStruct)
        .or(() => _figStruct_1.default)
        .or(() => _tableStruct_1.default)
        .or(() => _remarks_1.default))),
    Appdx: (factory_1.factory
        .choice(c => c
        .or(() => _arithFormula_1.default)
        .or(() => _remarks_1.default))),
};
const makeAppdxItemRule = (ruleName, tag) => {
    const contentBlockRule = (0, util_1.makeIndentBlockWithCaptureRule)(`${ruleName}ChildrenBlock`, appdxItemContentRule[tag]);
    const ret = factory_1.factory
        .withName("appdxItem")
        .sequence(s => s
        .and(r => r
        .oneMatch(({ item }) => {
        if (item.type === line_1.LineType.APP
            && item.line.mainTag === tag) {
            return item;
        }
        else {
            return null;
        }
    }), "titleLine")
        .and(r => r.zeroOrMore(() => util_1.$blankLine))
        .and(r => r
        .zeroOrOne(() => contentBlockRule), "contentBlock")
        .action(({ titleLine, contentBlock }) => {
        const children = [];
        const errors = [];
        const title = titleLine.line.title.length > 0 ? (0, std_1.newStdEL)(std.appdxItemTitleTags[std.appdxItemTags.indexOf(tag)], {}, titleLine.line.title, titleLine.line.titleRange) : null;
        if (title)
            children.push(title);
        const relatedArticleNum = titleLine.line.relatedArticleNum.length > 0 ? (0, std_1.newStdEL)("RelatedArticleNum", {}, titleLine.line.relatedArticleNum, titleLine.line.relatedArticleNumRange) : null;
        if (relatedArticleNum)
            children.push(relatedArticleNum);
        if (contentBlock) {
            children.push(...contentBlock.value.flat().map(v => v.value));
            errors.push(...contentBlock.value.flat().map(v => v.errors).flat());
            errors.push(...contentBlock.errors);
        }
        const pos = titleLine.line.indentsEndPos;
        const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
        if (range && pos !== null) {
            range[0] = pos;
        }
        const appdxItem = (0, std_1.newStdEL)(tag, {}, children, range);
        return {
            value: appdxItem,
            errors,
        };
    }));
    return ret;
};
exports.makeAppdxItemRule = makeAppdxItemRule;
/**
 * The parser rule for {@link std.AppdxFig}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$appdxItem.spec.ts) for examples.
 */
exports.$appdxFig = (0, exports.makeAppdxItemRule)("$appdxFig", "AppdxFig");
/**
 * The parser rule for {@link std.AppdxTable}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$appdxItem.spec.ts) for examples.
 */
exports.$appdxTable = (0, exports.makeAppdxItemRule)("$appdxTable", "AppdxTable");
/**
 * The parser rule for {@link std.AppdxStyle}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$appdxItem.spec.ts) for examples.
 */
exports.$appdxStyle = (0, exports.makeAppdxItemRule)("$appdxStyle", "AppdxStyle");
/**
 * The parser rule for {@link std.AppdxNote}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$appdxItem.spec.ts) for examples.
 */
exports.$appdxNote = (0, exports.makeAppdxItemRule)("$appdxNote", "AppdxNote");
/**
 * The parser rule for {@link std.AppdxFormat}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$appdxItem.spec.ts) for examples.
 */
exports.$appdxFormat = (0, exports.makeAppdxItemRule)("$appdxFormat", "AppdxFormat");
/**
 * The parser rule for {@link std.Appdx}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$appdxItem.spec.ts) for examples.
 */
exports.$appdx = (0, exports.makeAppdxItemRule)("$appdx", "Appdx");
//# sourceMappingURL=$appdxItem.js.map